module.exports = __webpack_public_path__ + "assets/img/steak.f196d1a6.png";